let overlay = null;

export function applyCursorOverlay(enabled, isXl) {
  if (enabled) {
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'pb-a11y-cursor-overlay';
      overlay.setAttribute('aria-hidden', 'true');

      const ring = document.createElement('div');
      ring.className = 'pb-a11y-cursor-ring';
      overlay.appendChild(ring);

      const dot = document.createElement('div');
      dot.className = 'pb-a11y-cursor-dot';
      overlay.appendChild(dot);
    }

    overlay.classList.toggle('pb-a11y-cursor-overlay--xl', isXl);
    overlay.classList.toggle('pb-a11y-cursor-overlay--large', !isXl);

    if (!overlay.parentNode) {
      document.body.appendChild(overlay);
    }

    document.documentElement.classList.add('pb-a11y-cursor-active');
  } else {
    if (overlay && overlay.parentNode) {
      overlay.parentNode.removeChild(overlay);
    }
    overlay = null;
    document.documentElement.classList.remove('pb-a11y-cursor-active');
  }
}

export function positionCursorOverlay(x, y) {
  if (overlay) {
    overlay.style.left = x + 'px';
    overlay.style.top = y + 'px';
  }
}

export function removeCursorOverlay() {
  if (overlay && overlay.parentNode) {
    overlay.parentNode.removeChild(overlay);
  }
  overlay = null;
  document.documentElement.classList.remove('pb-a11y-cursor-active');
}
